/** Aligns with `getNotificationTypeOptions` `value` (email vs in-app). */
export const NOTIFICATION_TYPE_EMAIL = 0;
export const NOTIFICATION_TYPE_APP = 1;
export const NOTIFICATION_TYPE_WHATSAPP = 2;

export const NOTIFICATION_FORM_I18N_KEYS = {
  SUBJECT: "pages.notificationForm.subject",
  SUBJECT_PLACEHOLDER: "pages.notificationForm.subjectPlaceholder",
  DESCRIPTION: "pages.notificationForm.description",
  DESCRIPTION_PLACEHOLDER: "pages.notificationForm.descriptionPlaceholder",
};

export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];
export const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;
